import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function SiteFooter() {
	 const { t } = useTranslation();
  return (
    <div class="row  overlayfooter">
			<div class="row">

				{/* <!-- About --> */}
				<div class="col-lg-4 footer_col">
					<div class="footer_about">
						<div class="logo_container" >
							<a href="#">
								<div class="logo_content d-flex flex-row align-items-end justify-content-start">
									{/* <div class="logo_img"><img src="./images/spst-home-icon.png" alt="logo" className="footerimage"/></div> */}
									<div><h3 className="footer-name" style={{color:'white'}}>{t("Temple_name")}</h3></div>
								</div>
							</a>
						</div>
						<div class="clear" style={{paddingTop:'20%'}}>
							<p className="foottest">{t("footer-text")}  </p>
							<div style={{width:'50px', display:'flex',gap:'10px'}}> 
								<a href="https://www.instagram.com/pattarath.chamundi.kshetram?igsh=MTU4cXRqeWNsdXc0NQ%3D%3D"><img src="./images/insta.webp" alt="Instagram" style={{width:'100%'}} /></a>
								<a href="https://www.facebook.com/people/Pattarath-Sree-Chamundeswari-Temple/61574023108045/?rdid=f9hZl5hHPfqaX6Uy&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1BodD4fzEU%2F"><img src="./images/facebook.png" alt="Instagram" style={{width:'250%'}} /></a>
							</div>
						</div>
						{/* <div class="footer_social">
							<ul>
								<li><a href="#"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
								<li><a href="#"><i class="fa fa-pinterest" aria-hidden="true"></i></a></li>
								<li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
								<li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
							</ul>
						</div> */}
						
					</div>
				</div>

				<div class="col-lg-4 footer_col">
					<div class="footer_links">
						<div class="footer_title">Quick menu</div>
						<ul className="footer_list">
							<li><Link to="/">{t("Home")}</Link></li>
							<li><Link to="#">{t("Online Bookiing")}</Link></li>
							<li><Link to="/History">{t("History")}</Link></li>
							<li><Link to="/Administration">{t("Administration")}</Link></li>
							<li><Link to="/Contact">{t("Contact")}</Link></li>
						</ul>
					</div>
				</div>

				{/* <div class="col-lg-2 footer_col">
					<div class="footer_links">
						<div class="footer_title">Useful Links</div>
						<ul class="footer_list">
							<li><Link to="https://booking.sreepadmanabhaswamytemple.org/">Online Booking</Link></li>
							<li><Link to="https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=75">Suvarna Darsan</Link></li>
							<li><Link to="https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=72">Kshethra Bhadratha Fund</Link></li>
							<li><Link to="https://booking.sreepadmanabhaswamytemple.org/Murajepam.aspx">Gosala Donation</Link></li>
						</ul>
					</div>
				</div> */}

				<div class="col-lg-4 footer_col">
					<div class="footer_contact">
						<div class="footer_title">Contact Us</div>
						<div class="footer_contact_info">
							<div class="footer_contact_item">
								<div class="footer_contact_title orange">Address:</div>
								<div class="footer_contact_line">
									<p style={{color:'white',lineHeight:'15pt'}}>{t("Address")}
                             </p> 
									{/* Ulsavamadam Building , North Nada<br />
									Sree Padmanabha Swamy Temple Fort,<br />
									Thiruvananthapuram – 695023.</p> */}
								</div>
							</div>
							<div class="footer_contact_item">
								<div class="footer_contact_title orange">Phone:</div>
								<div class="footer_contact_line white">0471-2490188, 9400570188 </div>
							</div>
							<div class="footer_contact_item">
								<div class="footer_contact_title orange">Email:</div>
								<div class="footer_contact_line white">pattarathchamundy@gmail.com</div>
							</div>
						</div>
					</div>
				</div>
				<div className="copyrightbottom">
					<div class="row">
					<div class="col-md-2" style={{padding:'0px'}}></div>			
						<div class="col-md-7" style={{padding:'0px'}}>
							<div class="copyrighttext">
								<p class="foottest" style={{lineHeight:'20px'}}>Copyright © 2026 Pattarath Sree Chamundeswari Kshetram Trust, All Rights Reserved.  <br/> 
								<Link to="./TermsAndConditions">Terms & Conditions </Link>, <Link to="./PrivacyPolicy">Privacy Policy</Link> Enabled by Kshethrasuvidham Temple Management Solutions.</p>
								
							</div>
						</div>
						<div class="col-md-3" style={{padding:'0px'}}>
							<div className="footerlogo">
								<img src="./images/kshethrasuvidhamLogo.jpg" style={{width:'50%'}} />
							</div>
						</div>
					</div>
					
					
				</div>
			</div>
		</div>
  );
}

export default SiteFooter;

